import { mapPathnameToAPI, mapPathnameToStore } from 'routes';
import { get } from 'lodash';
import { getAPIPath } from 'utils/environment';

// menu
export const menuEnter = () => ({
	type: 'MENU_ENTER'
})
export const menuSetActive = (slug) => ({
	type: 'MENU_SET_ACTIVE',
	slug: slug
})
export const menuExit = () => ({
	type: 'MENU_EXIT'
})
export const fetchConfig = () => {
	return ( dispatch, getState ) => {
		const path = getAPIPath('menu');
		return fetch( path )
			.then( response => response.json() )
			.then( json => {
				if ( json.data ) { dispatch( fetchConfigSuccess(json.data) ) }
				else { dispatch( fetchJSONFailure('No Config Data Found.', path) ) }
			})
			.catch( err => { dispatch( fetchJSONFailure(err, path) ) });
	}
}
export const fetchConfigSuccess = (data) => ({
	type: 'FETCH_CONFIG_SUCCESS',
	payload: {
		data: data
	}
})

// fetcher
export const fetchJSON = (dir, drawer) => {
	return ( dispatch, getState ) => {
		const delay = ms => x => new Promise(resolve => setTimeout( () => resolve(x), ms ));
		const path = getAPIPath(dir.join('/'));

		// for detecting fetch finish
		return new Promise((resolve, reject) => {
			const fetcherCache = get( getState().fetcher, drawer || dir, false );

			if(fetcherCache && fetcherCache.status){
				console.log('inner cache hit');
				console.log(fetcherCache);

				return setTimeout(() => {
					if(fetcherCache.status === 'success'){
						dispatch( fetchJSONSuccess(fetcherCache.data, path, dir, drawer) );
						resolve();
					} else {
						dispatch( fetchJSONFailure('fetcher-cache-says-error', path, dir, drawer) );
						reject();
					}
				}, 500);
			}

			setTimeout( () => {
				dispatch( fetchJSONBegin(path, dir, drawer) );
				return fetch( path )
					.then( delay(500) )
					.then( response => response.json() )
					.then( json => {
						if ( json.data ) { dispatch( fetchJSONSuccess(json.data, path, dir, drawer) ) }
						else { dispatch( fetchJSONFailure('No Data Found.', path, dir, drawer) ) }
					})
					.then(resolve)
					.catch( err => {
						dispatch( fetchJSONFailure(err, path, dir, drawer) );
						reject(err);
					});
			}, 0 );
		});
	}
}
export const fetchJSONByPath = (pathname) => {
	return fetchJSON( mapPathnameToAPI(pathname), mapPathnameToStore(pathname) );
}
export const fetchJSONBegin = (path, dir, drawer) => ({
	type: 'FETCH_JSON_BEGIN',
	payload: {
		path: path, 
		dir: dir,
		drawer: drawer,
	},
})
export const fetchJSONFailure = (err, path, dir, drawer) => ({
	type: 'FETCH_JSON_FAILURE',
	payload: {
		error: err,
		path: path,
		dir: dir,
		drawer: drawer,
	},
})
export const fetchJSONSuccess = (data, path, dir, drawer) => ({
	type: 'FETCH_JSON_SUCCESS',
	payload: {
		data: data,
		path: path,
		dir: dir,
		drawer: drawer,
	},
})

//status
export const pageChange = (pathname) => ({
	type: 'PAGE_CHANGE',
	pathname: pathname
})
export const sniffAgent = (device, os) => ({
	type: 'SNIFF_AGENT',
	payload: {
		device: device,
		os: os,
	}
})
export const showSiteIntro = () => ({
	type: 'SHOW_SITE_INTRO'
})
export const hideSiteIntro = () => ({
	type: 'HIDE_SITE_INTRO'
})
export const videoPlay = (ref) => ({
	type: 'VIDEO_PLAY',
	payload: {
		video: ref
	}
})


// WEBPACK FOOTER //
// ./src/actions.jsx